import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ACTIVITIES_FEATURE_KEY, State } from './activities.reducer';

export const getActivitiesState = createFeatureSelector<State>(ACTIVITIES_FEATURE_KEY);

export const getActivityLoaded = createSelector(getActivitiesState, (state: State) => state?.activity);

export const getLoading = createSelector(getActivitiesState, (state: State) => state?.loaded);

export const getStepsLoaded = createSelector(getActivitiesState, (state: State) => state.steps);
export const getTagsLoaded = createSelector(getActivitiesState, (state: State) => state.tags);
export const getFeaturesLoaded = createSelector(getActivitiesState, (state: State) => state.features);
export const getActivityRubricsLoaded = createSelector(getActivitiesState, (state: State) => state.rubrics);
export const getStatusActivityLoaded = createSelector(getActivitiesState, (state: State) => state.status);

export const getActivityStudentsStatus = createSelector(getActivitiesState, (state: State) => state.activity?.groupEvaluationStatus);
export const getRubricsMultiChoice = createSelector(getActivitiesState, (state: State) => state.rubricsMultiChoice);

export const getTeachingInfoActivityLoaded = createSelector(getActivitiesState, (state: State) => state.teachingInfo);
export const getMaterialsActivityLoaded = createSelector(getActivitiesState, (state: State) => state.materials);
export const getStudentAnswersActivityLoaded = createSelector(getActivitiesState, (state: State) => state.answers);
export const getAverageGrades = createSelector(getActivitiesState, (state: State) => state.averageGrades);
export const getStudentAverages = createSelector(getActivitiesState, (state: State) => state.averages);
export const getExercises = createSelector(getActivitiesState, (state: State) => state.activity?.exercises);
